import { getGoToFairePosCTA } from "./shared";
export var UnlinkingPosIA = function UnlinkingPosIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getGoToFairePosCTA;
        return (_getGoToFairePosCTA = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA === void 0 ? void 0 : _getGoToFairePosCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getGoToFairePosCTA2, _getGoToFairePosCTA2$;
        return (_getGoToFairePosCTA2 = getGoToFairePosCTA(context, strictLocalize)) === null || _getGoToFairePosCTA2 === void 0 ? void 0 : (_getGoToFairePosCTA2$ = _getGoToFairePosCTA2.getLink) === null || _getGoToFairePosCTA2$ === void 0 ? void 0 : _getGoToFairePosCTA2$.call(_getGoToFairePosCTA2);
      }
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return UNLINKING_POS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize), TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize)];
    }
  };
};
var UNLINKING_POS = function UNLINKING_POS(strictLocalize) {
  return strictLocalize({
    id: "asarqc",
    defaultMessage: [{
      "type": 0,
      "value": "Desassociar PDV"
    }]
  });
};
var TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION = function TO_DISCONNECT_YOUR_CURRENT_POS_INTEGRATION(strictLocalize) {
  return strictLocalize({
    id: "DsdM7O",
    defaultMessage: [{
      "type": 0,
      "value": "Para desassociar a integração de PDV atual, clique no botão do ícone de utilizador no canto superior direito do portal de revendedor e selecione a opção \"O meu PDV [NOME DA INTEGRAÇÃO]\". Nesta página, clique em \"Definições\" no canto superior direito. No menu Definições, desloque o ecrã para baixo até \"Desassociar o PDV [NOME DA INTEGRAÇÃO]\"."
    }]
  });
};
var TO_RECONNECT_A_DIFFERENT_ACCOUNT = function TO_RECONNECT_A_DIFFERENT_ACCOUNT(strictLocalize) {
  return strictLocalize({
    id: "4fMVwv",
    defaultMessage: [{
      "type": 0,
      "value": "Para voltar a ligar uma conta diferente, pode atualizar a página e clicar em \"Ligar à Square\", \"Ligar à Shopify\" ou \"Ligar à Clover\"."
    }]
  });
};